import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, ThemeProvider, Typography } from '@mui/material';
import clsx from 'clsx';

import { ReactComponent as Logo } from 'assets/icons/Logo.svg';

import { theme } from 'components/Theme/theme';

import { IFooterProps as IProps, ONE_PAGE_FOOTER_VARIANTS } from './types';

import styles from './Footer.module.scss';

const LOGO_LINK = 'https://growexa.com';

export const Footer: FC<IProps> = ({ variant = ONE_PAGE_FOOTER_VARIANTS.PRIMARY }) => {
  const { t } = useTranslation();
  return (
    <ThemeProvider theme={theme}>
      <Box
        component="footer"
        className={clsx(styles.footerWrapper, {
          [styles.lime]: variant === ONE_PAGE_FOOTER_VARIANTS.SECONDARY,
        })}
      >
        <a href={LOGO_LINK} className={styles.content}>
          <Typography variant="h4" component="p" style={{ fontWeight: 400 }}>
            {t('madeWith')}
          </Typography>
          <Logo className={styles.footerLogo} />
        </a>
      </Box>
    </ThemeProvider>
  );
};
